// extracted by mini-css-extract-plugin
module.exports = {"base":"organism2-m__base__2HRqe"};